import { mat4 } from "pex-math";
class Mesh {
  constructor(ctx) {
    this.ctx = ctx;
    this._positions = { data: null, buffer: null };
    this._uvs = { data: null, buffer: null };
    this._vertexColors = { data: null, buffer: null };
    this._offsets = { data: null, buffer: null };
    this._instanceUvs = { data: null, buffer: null };
    this._indices = { data: null, buffer: null };
    this._modelMatrix = mat4.create();
    this._instances = 0;
  }

  get modelMatrix() {
    return this._modelMatrix;
  }

  set instances(value) {
    this._instances = value;
  }

  get instances() {
    return this._instances;
  }

  set position(value) {
    mat4.identity(this._modelMatrix);
    mat4.translate(this._modelMatrix, value);
  }

  get positions() {
    return this._positions;
  }

  set positions(data) {
    this._positions.data = data;
    if (!this._positions.buffer) {
      this._positions.buffer = this.ctx.vertexBuffer(data);
    } else {
      this.ctx.update(this._positions.buffer, { data: data });
    }
  }

  get uvs() {
    return this._uvs;
  }

  set uvs(data) {
    this._uvs.data = data;
    if (!this._uvs.buffer) {
      this._uvs.buffer = this.ctx.vertexBuffer(data);
    } else {
      this.ctx.update(this._uvs.buffer, { data: data });
    }
  }

  get vertexColors() {
    return this._vertexColors;
  }

  set vertexColors(data) {
    this._vertexColors.data = data;
    if (!this._vertexColors.buffer) {
      this._vertexColors.buffer = this.ctx.vertexBuffer(data);
    } else {
      this.ctx.update(this._vertexColors.buffer, { data: data });
    }
  }

  get offsets() {
    return this._offsets;
  }

  set offsets(data) {
    this._offsets.data = data;
    if (!this._offsets.buffer) {
      this._offsets.buffer = this.ctx.vertexBuffer(data);
    } else {
      this.ctx.update(this._offsets.buffer, { data: data });
    }
  }

  get instanceUvs() {
    return this._instanceUvs;
  }

  set instanceUvs(data) {
    this._instanceUvs.data = data;
    if (!this._instanceUvs.buffer) {
      this._instanceUvs.buffer = this.ctx.vertexBuffer(data);
    } else {
      this.ctx.update(this._instanceUvs.buffer, { data: data });
    }
  }

  get indices() {
    return this._indices;
  }

  set indices(data) {
    this._indices.data = data;
    if (!this._indices.buffer) {
      this._indices.buffer = this.ctx.indexBuffer(data);
    } else {
      this.ctx.update(this._indices.buffer, { data: data });
    }
  }
}

export default Mesh;
